import { apiClient } from '@api/client'
import { TravelApi } from '@api/generated'

export const travelApi = new TravelApi(undefined, '', apiClient)
